import styled from 'styled-components';
import { ScEmblaPagination } from '@/components/EmblaCarousel/components/styled';
import {
  gemAnimation,
  reversedGemAnimation,
} from '@/modules/jackpot/components/JackpotGemsPack/styled';
import { device } from '@/styles/helpers';

export const ScJackpotBanner = styled.div`
  cursor: pointer;
  width: 100%;
  max-height: 128px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 4px 24px;
  gap: 24px;
  background-color: white;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.grayDarkColor};
  overflow: hidden;
  align-items: center;
  position: relative;
  z-index: 1;

  & .btn {
    display: none;
    height: 40px;
    max-width: 280px;
  }

  & .embla-slider-wrapper {
    width: 100%;
    display: none;

    & .embla__viewport {
      margin-top: -24px;
      margin-bottom: 48px;
    }

    & .embla__slide.last {
      flex: 0 0 100%;
    }

    & .embla__slide.active {
      position: relative;
      padding-left: 48px;

      &:not(:last-child):after {
        position: absolute;
        content: "";
        top: 0;
        right: 0;
        display: flex;
        width: 1px;
        height: 90px;
        align-items: flex-start;
        align-self: stretch;
        border-radius: 360px;
        background: radial-gradient(
          67.71% 84.17% at 50% 50%,
          rgba(255, 255, 255, 0.5) 0%,
          rgba(255, 255, 255, 0) 100%
        );
      }
    }

    @media (${device.mobileS}) {
      &.lang-fr-CA {
        & .embla__slide {
          &.active {
            padding-left: 32px;
          }
        }
      }
    }

    @media (max-width: 400px) {
      & .embla__slide {
        flex: 0 0 100%;
        &.active {
          padding-right: 16px;

          &:not(:last-child):after {
            right: 12px;
          }
        }
      }
    }

    @media (max-width: 340px) {
      & .embla__container {
        margin-left: -8px;
      }
      & .embla__slide {
        flex: 0 0 100%;
        &.active {
          padding-left: 8px;
          &:not(:last-child):after {
            right: px;
          }
        }
      }
      & .embla__viewport {
        padding-left: 8px;
      }
    }
  }

  & ${ScEmblaPagination} {
    padding: 0;
    bottom: -22px;
  }

  & > .bg {
    object-position: center left;
    z-index: -1;
  }

  & .logo {
    max-width: 238px;
    width: 100%;
    display: flex;
    align-items: center;

    img {
      width: 100%;
      object-fit: contain;
    }

    @media (${device.desktop}) {
      max-width: 190px;
    }
  }


  & .levels-container {
    display: flex;
    gap: 12px;
    align-items: center;
  }

  .bluredBlue,
  .green,
  .pink,
  .blue,
  .bluredPink,
  .bluredGreen {
    position: absolute;
    aspect-ratio: 1/1;
    z-index: -1;
  }

  .pink {
    width: 200px;
    top: -135px;
    left: 1000px;
    animation: ${reversedGemAnimation} infinite 7s ease-out;
  }

  .blue {
    width: 160px;
    top: -87px;
    left: 175px;
    animation: ${gemAnimation} infinite 7s ease-out;
  }

  .green {
    width: 160px;
    bottom: -95px;
    left: 685px;
    animation: ${reversedGemAnimation} infinite 7s ease-out;
  }

  .bluredBlue {
    width: 450px;
    bottom: -270px;
    left: 260px;
    animation: ${gemAnimation} infinite 7s ease-out;
  }

  .bluredPink {
    width: 470px;
    top: -340px;
    left: 865px;
    animation: ${gemAnimation} infinite 7s ease-out;
  }

  & .bluredGreen {
    display: none;
    width: 100%;
    height: 100%;
    left: -270px;
    bottom: -145px;
    animation: ${gemAnimation} infinite 7s ease-out;
  }

  @media (${device.tablet}) {
    & .logo {
      display: none;
    }
  }

  @media (${device.mobile}) {
    flex-direction: column;
    border-radius: 12px;
    padding: 12px 0;
    max-height: 344px;
    display: flex;
    align-items: center;
    gap: 0;

    & .logo {
      display: block;
      max-width: 312px;
      margin-bottom: -34px;
    }

    & .btn {
      display: block;
    }

    & .embla-slider-wrapper {
      display: block;
    }

    & > .bg {
      object-fit: cover;
      object-position: top center;
    }

    & > .logo {
      max-width: 110px;
      margin-top: -34px;
      margin-bottom: 0;
    }

    .pink {
      position: absolute;
      aspect-ratio: 1/1;
      z-index: -1;
    }

    .bluredBlue,
    .green {
      display: none;
    }

    .blue {
      width: 116px;
      height: 116px;
      top: 60px;
      right: -80px;
      left: unset;
    }

    .pink {
      top: -130px;
      left: -110px;
    }

    & .bluredGreen {
      display: block;
    }

    & .bluredPink {
      top: 150px;
      right: auto;
      bottom: auto;
      left: 0px;
    }
  }

  @media (max-width: 320px) {
    .blue {
      display: none;
    }
  }
`;
